export const state = {
  printThemes: [],
  printLayouts: [],
  digitalThemes: [],
  digitalLayouts: []
};
